<template>
  <div class="asc-dialog-header">
    <asc-dialog-subtitle
      v-if="showTitle"
      :value="value"
      class="asc-dialog-subtitle"
    ></asc-dialog-subtitle>

    <v-spacer v-else></v-spacer>
    <asc-close-button
      v-if="showCloseButton"
      :on-close="handleCloseClick"
      aria-label="Close Button"
      class="asc-close-button"
      :size="16"
    ></asc-close-button>
  </div>
</template>

<script>
import AscDialogSubtitle from './AscDialogSubtitle'
import AscCloseButton from './AscCloseButton'

export default {
  name: 'AscDialogHeader',

  components: {
    AscDialogSubtitle,
    AscCloseButton,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    showTitle: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    handleCloseClick() {
      if (this.onClose) {
        this.onClose()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-dialog-header {
  display: flex;
  width: 100%;
}

.asc-dialog-subtitle {
  flex: 1;
}

.asc-close-button {
  align-self: flex-start;
  min-width: 18px !important;
  height: 18px !important;
}
</style>
